import type { SxStyle } from '@aibees/shared/theme';

export const badge: SxStyle = {
  backgroundColor: (p) => p.palette.warning[100],
  color: (p) => p.palette.warning[700],
  borderRadius: 0.5,
  padding: (p) => p.spacing(0.5, 1),
  fontSize: (p) => p.typography.caption,
  fontWeight: 700,
};

export const paper: SxStyle = {
  mt: 0.5,
  maxHeight: (p) => p.spacing(29),
  borderRadius: 1,
  backgroundColor: (p) => p.palette.common.white,
  border: (p) => `1px solid ${p.palette.primary[500]}`,
};

export const menuItem: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
  '&.Mui-selected': {
    backgroundColor: (p) => p.palette.common.white,
  },
  '&:hover': {
    backgroundColor: (p) => p.palette.common.white,
  },
};

export const icon: SxStyle = {
  color: (p) => p.palette.success[500],
};
